<template>
  <section class="publication-single">
    <NewsSingleHeader :publication="publication" />
    <NewsSingleContent v-if="publication && publication.content" :publication="publication" />
    <NewsSingleMore v-if="publication" :publication="publication" />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'NewsSingle',
  components: { ...partials },
  props: {
    newsSlug: String
  },
  computed: {
    publication() {
      if (!this.$wp.secondaryDataLoaded) return null
      return this.$wp.allPublications[this.newsSlug] || null
    }
  },
  mounted() {
    this.$watch(
      '$wp.secondaryDataLoaded',
      isLoaded => {
        if (isLoaded) {
          console.log('News item loaded:', this.publication)
        }
      },
      { immediate: true }
    )
  }
}
</script>
